<template>
    <b-container>
        <h1 class="text-center pt-4 pb-4">{{ $t("title.taskAssignment") }}</h1>

        <div v-if="groups.length > 0">
            <b-row class="pt-2">
                <b-col sm="4" class="mt-2">
                    <b-form-select v-model="perPage" :options="options"></b-form-select>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
                    <b-button variant="link" @click="resetTable()">{{
                        $t("action.reset")
                    }}</b-button>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <div>{{ $t("label.tablesize") }} {{ rows }}</div>
                </b-col>
            </b-row>

            <b-row class="pt-2" v-if="teamSelect.length > 0 && teamSelect.length < maxPlannerGroupLength">
                <b-col sm="4" class="mt-2">
                    <b-button class="mt-2" variant="outline-success" @click="openmodal('confirmedTaskAssignment')">{{
                        $t("action.assignTask") }}</b-button>
                    <b-modal size="xl" id="confirmedTaskAssignment" :title="$t('title.taskAssignment')" hide-footer>
                        <confirmedTaskAssignment :teamSelect="teamSelect" modalid="confirmedTaskAssignment" />
                    </b-modal>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-alert show variant="info" class="mt-4">
                        <p>{{ $t("info.plannerGroupMaxLength") }}</p>
                        <p>{{ $t("label.numberOfGroupSelect") }} : {{ teamSelect.length }}</p>
                    </b-alert>
                </b-col>
                <b-col>
                    <b-form-checkbox class="mt-4" v-model="selectAll" name="select-all" switch>{{ $t("action.selectAll")
                    }}</b-form-checkbox>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col class="lgTable">
                    <b-table id="groupTable" stacked="lg" bordered :fields="myfields" :items="items" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:cell(assignment)="row">
                            <b-button variant="link" class="ml-2" size="sm" @click="openmodal('membersModal', row.item)">{{
                                $t("action.chooseMembers") }}</b-button>
                        </template>
                        <template v-slot:cell(details)="row">
                            <b-button :variant="row.item.variant" class="ml-2" size="sm" @click="chooseGroup(row.item)">{{
                                $t("action.choose") }}</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col sm="6" class="mt-2">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="groupTable"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <b-modal id="membersModal" :title="$t('action.chooseMemberOfTeam')" hide-footer>
            <ChooseMembers :rowItem="rowItem" :showBtn="true" modalid="membersModal" />
        </b-modal>

        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>
  
<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import confirmedTaskAssignment from "./ConfirmedTaskAssignment.vue";
import ChooseMembers from "../../modal/ChooseMembers.vue";

export default {
    mixins: [globalF],
    data() {
        return {
            error: "",
            spinner: false,
            AllGroups: [],
            groups: [],
            sortBy: "NOMDIV",
            sortDesc: false,
            perPage: 10,
            currentPage: 1,
            search: "",
            options: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            teamSelect: [],
            selectAll: false,
            selectOnt: false,
            selectBuilding: false,
            selectUser: false,
            taskList: [],
            taskSelect: null,
            rowItem: null,
            maxPlannerGroupLength: 26
        };
    },
    mounted() {
        this.$root.$on("bv::modal::hide", () => {
            this.getBuildingListForDr();
        });
        this.getBuildingListForDr();
    },
    computed: {
        user: function () {
            return this.$store.getters.getUser;
        },
        url: function () {
            return this.getUrl();
        },
        rows() {
            return this.items.length;
        },
        items: function () {
            let mydatalist = this.groups;
            let search = this.search.toLowerCase();
            return mydatalist.filter(
                (p) =>
                    p.NOMDIV.toString().toLowerCase().includes(search) ||
                    p.GroupName.toString().toLowerCase().includes(search)
            );
        },
        myfields: function () {
            return [
                {
                    key: "NOMDIV",
                    sortable: true,
                    label: this.$t("label.building"),
                },
                {
                    key: "GroupName",
                    sortable: true,
                    label: this.$t("label.nameOfTheGroup"),
                },
                {
                    key: "UniqueId",
                    sortable: true,
                    label: "UniqueId",
                },
                {
                    key: "Language",
                    sortable: true,
                    label: this.$t("label.language"),
                },
                { key: "assignment", label: this.$t("action.chooseMembers") },
                { key: "members", label: this.$t("label.assignment") },
                { key: "details", label: this.$t("label.edit") },
            ];
        },
    },
    watch: {
        selectAll: function (val) {
            this.teamSelect = [];
            this.groups = this.AllGroups.map((g) => {
                g.variant = "outline-success";
                return g;
            });
            let tableInfo = this.AllGroups;
            if (val) {
                this.teamSelect = tableInfo;
                this.groups = tableInfo.map((g) => {
                    g.variant = "success";
                    return g;
                });
            }
        },
        selectOnt: function (val) {
            this.teamSelect = [];
            this.groups = this.AllGroups.map((g) => {
                g.variant = "outline-success";
                return g;
            });
            let tableInfo = this.AllGroups;
            if (val) {
                this.teamSelect = tableInfo.filter(t => t.Status === 3);
                this.groups = tableInfo.map((g) => {
                    g.variant = "success";
                    return g;
                });
            }
        },
        selectBuilding: function (val) {
            this.teamSelect = [];
            this.groups = this.AllGroups.map((g) => {
                g.variant = "outline-success";
                return g;
            });
            let tableInfo = this.AllGroups.filter((g) => g.groupType === "building");
            if (val) {
                this.teamSelect = tableInfo;
                this.groups = tableInfo.map((g) => {
                    g.variant = "success";
                    return g;
                });
            }
        },
        selectUser: function (val) {
            this.teamSelect = [];
            this.groups = this.AllGroups.map((g) => {
                g.variant = "outline-success";
                return g;
            });
            let tableInfo = this.AllGroups.filter((g) => g.groupType === "user");
            if (val) {
                this.teamSelect = tableInfo;
                this.groups = tableInfo.map((g) => {
                    g.variant = "success";
                    return g;
                });
            }
        },
    },
    methods: {
        resetTable: function () {
            this.search = "";
        },
        getBuildingListForDr() {
            this.spinner = true;
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;

            let promise = this.validateToken();
            promise.then(() => {
                axios
                    .post(
                        url,
                        { request: "getBuildingListForDr", userId: this.user.Id },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.spinner = false;
                        let userBuildings = response.data.buildings;
                        let teamBuildings = response.data.teamBuildings;

                        let teamBuildingsForDr = teamBuildings.filter(t => {
                            return userBuildings.find(u => u.Id == t.IdBuilding);
                        });

                        let mapTeamBuilding = teamBuildingsForDr.map((t) => {
                            t.groupType = "building";
                            return t;
                        });
                        let groups = mapTeamBuilding;

                        let groupMembersList = this.$store.getters.getGroupMembersList;

                        this.groups = groups.map((b) => {
                            b.members = "";
                            b.membersList = [];
                            if (groupMembersList.length > 0) {
                                let members = groupMembersList.find(
                                    (m) => m.rowItem.GroupId === b.GroupId
                                );
                                if (members) {
                                    let membersList = members.members.map((m) => m.displayName);
                                    b.members = membersList.toString();
                                    b.membersList = members.members;
                                }
                            }
                            if (this.teamSelect.length > 0) {
                                let find = this.teamSelect.find((t) => t.GroupId === b.GroupId);
                                if (find) {
                                    b.variant = "success";
                                } else {
                                    b.variant = "outline-success";
                                }
                            } else {
                                b.variant = "outline-success";
                            }
                            return b;
                        });

                        this.AllGroups = groups;
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            });
        },
        chooseGroup: function (group) {
            let tableInfo = this.groups;
            let teamSelect = this.teamSelect;

            let find = teamSelect.find((t) => t.GroupId === group.GroupId);
            if (find) {
                this.teamSelect = teamSelect.filter((t) => t.GroupId !== group.GroupId); //s'il est là je l'enlève
                this.groups = tableInfo.map((g) => {
                    if (g.GroupId === find.GroupId) {
                        g.variant = "outline-success"; //je remet le bouton outline-success
                    }
                    return g;
                });
            } else {
                this.teamSelect.push(group); //s'il n'est pas là je l'ajoute
                this.groups = tableInfo.map((g) => {
                    if (g.GroupId === group.GroupId) {
                        g.variant = "success"; //je met le bouton success
                    }
                    return g;
                });
            }
        },
        setNextPage(page) {
            this.$emit("changePage", page);
        },
        openmodal: function (id, rowItem) {
            if (id === "confirmedTaskAssignment") {
                for (let i = 0; i < this.teamSelect.length; i++) {
                    let teamSelect = this.teamSelect[i];
                    let find = this.groups.find((t) => t.GroupId === teamSelect.GroupId);
                    if (find) {
                        teamSelect.membersList = find.membersList;
                        teamSelect.members = find.members;
                    }
                }
            }
            this.rowItem = rowItem;
            this.$bvModal.show(id);
        },
    },
    components: {
        confirmedTaskAssignment,
        ChooseMembers
    },
};
</script>
  